import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setNextModal, openOrderLocationModal, openPaymentModal, openOrderNameModal, openOrderNoteModal, openOrderDiscountModal, openOpenOrders } from '../actions/index';
import _ from 'lodash';

class PosOrderNav extends Component {

  // Handle clicking on the send button
  handleSendButton = () => {
    // Must have at least one item in the order to move on
    if (!(_.isEmpty(this.props.current_order.items))) {
      this.props.openOrderLocationModal();
    }
  }

  render() {
    return(
      <div className="col-sm-auto text-xs-center text-md-right pr-1 pl-1">
        <div className="pt-2 hidden-sm-up"></div>
        <button type="submit" onClick={event => this.handleSendButton()} className="btn btn-primary btn-rounded w-min-xs mb-0-25 waves-effect waves-light">
          <span>Send</span>
        </button>
        &nbsp;
        <button type="submit" onClick={event => this.props.openOrderNoteModal()} className="btn btn-primary btn-rounded w-min-xs mb-0-25 waves-effect waves-light">
          <span>Note</span>
        </button>
        &nbsp;
        <button type="submit" onClick={event => this.props.openOrderDiscountModal()} className="btn btn-primary btn-rounded w-min-xs mb-0-25 waves-effect waves-light">
          <span>Discount</span>
        </button>
      </div>
    );
  }
}

function mapStateToProps({ current_order, modals }) {
  return { current_order, modals };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators( { setNextModal, openOrderLocationModal, openPaymentModal, openOrderNameModal, openOrderNoteModal, openOrderDiscountModal, openOpenOrders }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PosOrderNav);



// WEBPACK FOOTER //
// ./src/containers/pos_order_nav.js